import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=64a6361a&scoped=true"
import script from "./navItem.vue?vue&type=script&lang=js"
export * from "./navItem.vue?vue&type=script&lang=js"
import style0 from "./navItem.vue?vue&type=style&index=0&id=64a6361a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6361a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a6361a')) {
      api.createRecord('64a6361a', component.options)
    } else {
      api.reload('64a6361a', component.options)
    }
    module.hot.accept("./navItem.vue?vue&type=template&id=64a6361a&scoped=true", function () {
      api.rerender('64a6361a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/navigation-panel/navItem.vue"
export default component.exports